import { createSelector } from 'reselect'
import * as selectors from './selectors'

export const orgHandle = state => state.getIn(['orgUI', 'data', 'handle'])

export const isValidOrgHandle = createSelector(
  orgHandle,
  selectors.orgHandle,
  state => state.getIn(['orgUI', 'valid', 'handle']),
  (handle, originalHandle, valid) => {
    if (handle === originalHandle || typeof valid === 'undefined') return true

    return valid && !!handle && handle.length > 0 && !handle.includes('.')
  }
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/selectorsUI.js